import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
/**
 * Delete System Logo Request Schema
 * DELETE /api/v2/system-logo/:systemId
 * Deletes the system's logo
 */ export const DeleteSystemLogoRequestSchema = z.object({
    systemId: z.string()
});
/**
 * Delete System Logo Response Schema
 */ export const DeleteSystemLogoResponseSchema = z.object({
    success: z.boolean()
});
/**
 * Delete System Logo Error Schema
 */ export const DeleteSystemLogoErrorSchema = BaseErrorSchema;

//# sourceMappingURL=delete-system-logo.schema.js.map